module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if(_.size(compare)){ 
__p+='\n	';
 _.each(stats, function(stat){ 
__p+='\n		<div class="chart-line '+
((__t=( stat.is_coach_only ? 'is-coach' : '' ))==null?'':_.escape(__t))+
'">\n			<div class="chart-line-left '+
((__t=( stat.left_is_less ? 'is-less' : '' ))==null?'':_.escape(__t))+
'">\n				<div class="chart-line-size">\n					<div class="chart-line-val" style="width: '+
((__t=( (stat.is_coach_only && !has_assistant_coach) ? 2 : stat.left_val_percent ))==null?'':_.escape(__t))+
'%"></div>\n				</div>\n				<div class="chart-line-text">\n					';
 if(stat.is_coach_only){ 
__p+='\n						';
 if(has_assistant_coach) { print(stat.left_val) } else { 
__p+='\n						<!-- User has no assistant coach but trigger to show coach data -->\n						<img class="coach-locked js-coach-locked" src="/assets/images/icon-coach-locked.png" alt="">\n						';
 } 
__p+='\n					';
 } else { print(stat.left_val) } 
__p+='\n				</div>\n			</div>\n			<div class="chart-line-center">'+
((__t=( typeof stat.title === 'function' ? stat.title() : stat.title ))==null?'':_.escape(__t))+
'</div>\n			<div class="chart-line-right '+
((__t=( stat.right_is_less ? 'is-less' : '' ))==null?'':_.escape(__t))+
' '+
((__t=( stat.right_is_empty ? 'is-empty' : '' ))==null?'':_.escape(__t))+
'">\n				<div class="chart-line-text">\n					';
 if(stat.is_coach_only){ 
__p+='\n						';
 if(has_assistant_coach) { print(stat.right_val) } else { 
__p+='\n						<!-- User has no assistant coach but trigger to show coach data -->\n						<img class="coach-locked js-coach-locked" src="/assets/images/icon-coach-locked.png" alt="">\n						';
 } 
__p+='\n					';
 } else { print(stat.right_val) } 
__p+='\n				</div>\n				<div class="chart-line-size">\n					<div class="chart-line-val" style="width: '+
((__t=( (stat.is_coach_only && !has_assistant_coach) ? 2 : stat.right_val_percent ))==null?'':_.escape(__t))+
'%"></div>\n				</div>\n			</div>\n		</div>\n	';
 }) 
__p+='\n';
 } 
__p+='';
}
return __p;
};
